module.exports = __webpack_public_path__ + "static/media/abdos.2e9296d0.jpg";